/**
 * Singleton pour gérer l'instance du client Excel
 */

import { DevanaWSClient } from "@devana/ws-tools";
import { createExcelClient } from "./excelClientLib";

let excelClientInstance: DevanaWSClient | null = null;

export function getOrCreateExcelClient(
  apiUrl: string,
  options?: {
    documentName?: string;
    bearerToken?: string;
    callbacks?: {
      onConnected?: (sessionId: string) => void;
      onReconnected?: (sessionId: string) => void;
      onDisconnected?: () => void;
      onError?: (error: Error) => void;
      onSessionsChanged?: () => void;
    }
  }
): DevanaWSClient {
  // Si le client existe déjà et est connecté, le retourner
  if (excelClientInstance && excelClientInstance.isConnected()) {
    console.log("[ExcelClientSingleton] ♻️ Returning existing connected client");
    return excelClientInstance;
  }

  // Si le client existe mais n'est pas connecté, le déconnecter proprement
  if (excelClientInstance) {
    console.log("[ExcelClientSingleton] 🔄 Client exists but not connected, recreating...");
    try {
      excelClientInstance.disconnect();
    } catch (e) {
      console.error("[ExcelClientSingleton] Error disconnecting old client:", e);
    }
    excelClientInstance = null;
  }

  // Créer un nouveau client
  console.log("[ExcelClientSingleton] 🆕 Creating new Excel client");
  excelClientInstance = createExcelClient(apiUrl, options);

  // Connecter le client
  excelClientInstance.connect();

  return excelClientInstance;
}

export function disconnectExcelClient() {
  if (excelClientInstance) {
    console.log("[ExcelClientSingleton] 🔌 Disconnecting client");
    excelClientInstance.disconnect();
    excelClientInstance = null;
  }
}

export function getExcelClientInstance(): DevanaWSClient | null {
  return excelClientInstance;
}